import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { Wrapper, HeaderWrapper, IconWrapper, Title } from "./LabeledSection";

const LabeledSectionBottomSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
}));

export function LabeledSectionSkeleton() {
    return (
        <Wrapper>
            <HeaderWrapper>
                <IconWrapper>
                    <Skeleton variant="rectangular" width={35} height={35} />
                </IconWrapper>
                <Title>
                    <Skeleton variant="rectangular" width={80} height={28} />
                </Title>
            </HeaderWrapper>
            <LabeledSectionBottomSkeleton>
                <Skeleton variant="rectangular" width="93%" height={20} />
                <Skeleton variant="rectangular" width="100%" height={20} />
                <Skeleton variant="rectangular" width="97%" height={20} />
            </LabeledSectionBottomSkeleton>
        </Wrapper>
    );
}
